import React, {Component, Fragment} from 'react';
import HeaderForm1 from './HeaderForm1'
import CanvasContext from './CanvasContext'
import {
    BrowserRouter as Router,
    Route,
    Link,
  } from 'react-router-dom';
  
  
 class HeaderList extends Component
{
    constructor(props) {
        super(props);
        this.state = {page: 'main'};
        this.documentID = props.documentID;
    }

    goTo(site)
    {
          this.setState({ page: site});
    }

    render()
    {
        var divStyle = {
            height: "220px"
          };
          
        let home = () =>
        <div class="flex-fill flex-column align-items-start justify-content-center">
          <CanvasContext.Consumer>
          {(context) =>
          context.Navbar(`/dashboard/${this.documentID}`)      
          }
           </CanvasContext.Consumer>
        <Link to={`/dashboard/${this.documentID}/addheader/1`}>
        <button type="button" class="btn btn-outline-success btn-lg btn-block" style={divStyle}>1</button>
        </Link>
        <button type="button" class="btn btn-outline-success btn-lg btn-block" style={divStyle}>2</button>
        <button type="button" class="btn btn-outline-success btn-lg btn-block" style={divStyle}>3</button>
        <button type="button" class="btn btn-outline-success btn-lg btn-block" style={divStyle}>4</button>
        <button type="button" class="btn btn-outline-success btn-lg btn-block" style={divStyle}>5</button>
        <button type="button" class="btn btn-outline-success btn-lg btn-block" style={divStyle}>6</button>
        </div>
 
          let _1 = () =>
          <div class="flex-fill d-flex justify-content-center align-items-start">
             <HeaderForm1 documentID={this.documentID}/>
          </div>
        
        return(
          <Fragment>
            <Route exact path={`/dashboard/${this.documentID}/addheader`} component={home} />
            <Route path={`/dashboard/${this.documentID}/addheader/1`} component={_1} />
          </Fragment>
        );
    }

}

export default HeaderList